
































































import Vue from 'vue'
import { Switch, Slider, ColorPicker, CheckboxButton, Button } from 'element-ui'
import { cloneDeep } from 'lodash'

interface ChromaKeyParameters {
  screen: string
  weight: number
  balance: number
  clipblack: number
  clipwhite: number
}

export default Vue.extend({
  name: 'ChromaKeySliders',
  props: {
    pickingMode: {
      type: Boolean
    },
    videoId: {
      type: String
    },
    value: {
      type: Object as () => ChromaKeyParameters,
      required: true
    }
  },
  data () {
    return {
      mypickingmode: false,
      localChromakey: cloneDeep(this.value)
    }
  },
  watch: {
    pickingMode () {
      if (this.pickingMode !== this.mypickingmode) {
        this.mypickingmode = this.pickingMode
      }
    },
    mypickingmode () {
      if (this.pickingMode !== this.mypickingmode) {
        this.$emit('setPickingMode', this.mypickingmode)
      }
    },
    localChromakey: {
      handler () {
        this.$emit('input', this.localChromakey)
      },
      deep: true
    }
  },
  computed: {
    clipRange: {
      get: function (): [number, number] {
        return [this.localChromakey.clipblack, this.localChromakey.clipwhite]
      },
      set: function (newValue: [number, number]) {
        this.localChromakey.clipblack = newValue[0]
        this.localChromakey.clipwhite = newValue[1]
      }
    }
  },
  methods: {
    pick () {
      console.log('pick ' + this.videoId)
      this.$emit('setPickingMode', true)
    },
    colorPicked (color) {
      console.log('colorPicked ' + color)
      this.localChromakey.screen = color
    },
    reset () {
      this.localChromakey.screen = '#20AA20'
      this.localChromakey.weight = 10
      this.localChromakey.balance = 20
      this.localChromakey.clipblack = 30
      this.localChromakey.clipwhite = 80
    }
  },
  components: {
    'el-slider': Slider,
    'el-color-picker': ColorPicker,
    'el-switch': Switch,
    'el-checkbox-button': CheckboxButton,
    'el-button': Button
  }
})
